import React from 'react';
import './BubbleFormGroup.scss';

interface BubbleFormGroupPropsBase {
  label?: string;
  labelClassName?: string;
  labelFn?: (props: BubbleFormGroupProps) => React.ReactNode;
  asterisk?: boolean;
  error?: unknown;
}

type BubbleFormGroupProps = BubbleFormGroupPropsBase & React.HTMLAttributes<HTMLElement>;

export default function BubbleFormGroup(props: BubbleFormGroupProps) {
  const {
    // from component
    label,
    labelClassName: propLabelClasses,
    labelFn,
    asterisk,
    error,
    // from div
    className: propClasses,
    children,
    ...rest
  } = props;

  const labelToUse = labelFn ? labelFn(props) : label;

  const classes = ['bubble-formgroup'];
  if (error) classes.push('has-errors');
  if (propClasses) classes.push(propClasses);

  const labelClasses = ['bubble-fg-label'];
  if (propLabelClasses) labelClasses.push(propLabelClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className={labelClasses.join(' ')}>
        {labelToUse}
        {asterisk && <span className="text-crimson">&nbsp;*</span>}
      </div>
      {children}
      {error && <div className="text-crimson mt-1">{error.toString()}</div>}
    </div>
  );
}
